<template>


    <div>
        <div class="fixed bg-white w-full shadow flex px-5 z-50">
            <div class="w-2/12 flex items-center">
                <img width="60" src="../assets/img/ezilly-logo.png">
                <h1 class="ml-6 text-2xl text-gray-800 uppercase" style="font-family: 'M7 Sans'">Marktime</h1>
            </div>
            <div class="w-10/12 flex justify-between">
                <h1 class="text-xl text-gray-800 border-gray-400 uppercase ml-1 py-5">Ezilly Vacations Calendar</h1>
            </div>
            <div class="flex items-center mr-6">
                <a class="flex" href="#" @click.prevent="logout">
                    <Zondicon icon="arrow-outline-left" class="w-4 h-6 mr-3 fill-current" />
                    <span class="text-sm">Logout</span>
                </a>
            </div>
        </div>
        
        <div class="pt-20 mx-8">
            <Calendar></Calendar>
        </div>

    </div>


</template>

<script>
import Calendar from '@/components/Calendar.vue';
import Zondicon from 'vue-zondicons';
import { auth } from '@/firebase'

export default {
    
    components: {
		Calendar,
        Zondicon
	},

    methods: {
        logout() {
            auth.signOut().then(() => {
                this.$router.go('login');
            })
        }
    }
    
}
</script>
